import { render, staticRenderFns } from "./SeoCard.vue?vue&type=template&id=6cb3d070&"
import script from "./SeoCard.vue?vue&type=script&lang=js&"
export * from "./SeoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports